enum ARTICLE_LANGUAGES {
  EN = 'en',
  ES = 'es',
  PT_BR = 'pt-BR',
}

enum HELP_STATE_ACTIONS {
  DISMISSED = 'dismissed',
  SEEN = 'seen',
}

enum HELP_TIP_STATUS {
  ENDED = 'ended',
  HIDDEN = 'hidden',
  SHOWING = 'showing',
}

enum HELP_STATE_TYPES {
  MENU = 'menu',
  ANNOUNCEMENT = 'announcement',
}

enum WHATS_NEW_STATUS {
  DRAFT = 'draft',
  PUBLISHED = 'published',
}

export { ARTICLE_LANGUAGES, HELP_STATE_ACTIONS, HELP_STATE_TYPES, HELP_TIP_STATUS, WHATS_NEW_STATUS };
